import {ApiClient} from './api'

export class AdyenPaymentsDetailsService {
    baseUrl = '/mobify/api/adyen/payments/details'
    apiClient = null

    constructor(token, site) {
        this.apiClient = new ApiClient(this.baseUrl, token, site)
    }

    async submitPaymentsDetails(data, customerId, locale) {
        const res = await this.apiClient.post({
            body: JSON.stringify({
                data,
            }),
            headers: {
                customerid: customerId,
                locale,
            },
        })
        if (res.status >= 300) {
            throw new Error(res)
        } else {
            return await res.json()
        }
    }
}
